/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The UnitForm model module.
   * @module textbook/model/UnitForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>UnitForm</code>.
   * @alias module:textbook/model/UnitForm
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>UnitForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/UnitForm} obj Optional instance to populate.
   * @return {module:textbook/model/UnitForm} The populated <code>UnitForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textBookId')) {
        obj['textBookId'] = ApiClient.convertToType(data['textBookId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'versionNum')) {
        obj['versionNum'] = ApiClient.convertToType(data['versionNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'serialName')) {
        obj['serialName'] = ApiClient.convertToType(data['serialName'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'freeTrial')) {
        obj['freeTrial'] = ApiClient.convertToType(data['freeTrial'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'folderName')) {
        obj['folderName'] = ApiClient.convertToType(data['folderName'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'md5')) {
        obj['md5'] = ApiClient.convertToType(data['md5'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'separator')) {
        obj['separator'] = ApiClient.convertToType(data['separator'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 教材id
   * @member {Integer} textBookId
   */
  exports.prototype['textBookId'] = undefined;
  /**
   * 0未上线；1上线
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 压缩包版本号，用于升级
   * @member {String} versionNum
   */
  exports.prototype['versionNum'] = undefined;
  /**
   * 编号名
   * @member {String} serialName
   */
  exports.prototype['serialName'] = undefined;
  /**
   * 名称
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 是否免费
   * @member {Boolean} freeTrial
   */
  exports.prototype['freeTrial'] = undefined;
  /**
   * unit源码文件夹名
   * @member {String} folderName
   */
  exports.prototype['folderName'] = undefined;
  /**
   * 压缩包md5
   * @member {String} md5
   */
  exports.prototype['md5'] = undefined;
  /**
   * 是否为虚拟章
   * @member {Boolean} separator
   */
  exports.prototype['separator'] = undefined;



  export default exports;
;


